import './NavBar.scss';
import { Dispatch, ReactNode, SetStateAction } from 'react';
import { MdArrowForwardIos } from 'react-icons/md';
import { Appearance, Background } from '../designConstants';
import { IconButton } from '../IconButton';
import { InteractiveDiv } from '../InteractiveEl';

interface ExpanderProps {
  setExpanded: Dispatch<SetStateAction<boolean>>;
}

export const Expander = ({ setExpanded }: ExpanderProps): ReactNode => (
  <InteractiveDiv
    data-testid='nav-expander'
    className='nav-expander-container'
    onClick={() => setExpanded(curr => !curr)}
  >
    <IconButton
      className='nav-expander-icon'
      appearance={Appearance.EMPTY}
      background={Background.DARK}
    >
      <MdArrowForwardIos color='white' />
    </IconButton>
  </InteractiveDiv>
);
